import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OrderCashierByCartQuery, OrderCashierByCartVo } from './type';

/**
 * 通过购物车下单
  POST /api/order/buyer/buy/cart
  接口ID：234956503
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956503
 */
export const postCashierByCart = (data: OrderCashierByCartQuery): AxiosPromise<OrderCashierByCartVo> => {
  return request({
    url: '/api/order/buyer/buy/cart',
    method: 'post',
    data
  });
};
